import { BrowserStorage } from 'UTILS/browserStorage'

const LAST_RELOAD_KEY = 'staleChunkReloadedAt'
const RELOAD_COOLDOWN_MS = 10_000
const STALE_CHUNK_MESSAGE =
  /dynamically imported module|Importing a module script failed|Unable to preload CSS/i

const session = new BrowserStorage(sessionStorage)
let reloading = false

const reloadPage = (): void => {
  location.reload()
}

const reloadedRecently = (): boolean => {
  const reloadedAt = session.getItem<number>(LAST_RELOAD_KEY)

  return reloadedAt !== null && Date.now() - reloadedAt < RELOAD_COOLDOWN_MS
}

export const isStaleChunkError = (error: unknown): boolean =>
  error instanceof Error && STALE_CHUNK_MESSAGE.test(error.message)

const reloadForStaleChunk = (error: unknown, reload: () => void): boolean => {
  if (reloading) {
    return true
  }

  if (!isStaleChunkError(error) || reloadedRecently()) {
    return false
  }

  reloading = true
  session.setItem(LAST_RELOAD_KEY, Date.now())
  reload()

  return true
}

export const loadRouteModule = async <T>(
  load: () => Promise<T>,
  reload: () => void = reloadPage,
): Promise<T> => {
  try {
    return await load()
  } catch (error) {
    if (!reloadForStaleChunk(error, reload)) {
      throw error
    }

    return await new Promise<never>(() => {})
  }
}

export const listenForStaleChunks = (reload: () => void = reloadPage): (() => void) => {
  const handlePreloadError = (event: VitePreloadErrorEvent): void => {
    reloadForStaleChunk(event.payload, reload)
  }

  window.addEventListener('vite:preloadError', handlePreloadError)

  return () => {
    window.removeEventListener('vite:preloadError', handlePreloadError)
  }
}
